<template>
   
    <div class="textbox" style="width: 100%;">
        <label>Manufacturer Code</label>
        <div>
            <InputText :placeholder="placeholder" v-model="inputText"/>
            <Button label="Check" severity="info" @click="CheckManufacturerCode()"   />
        </div>
    </div>
    <Dialog v-model:visible="showDialog" modal header="Manufacturer Code" :style="{ width: '60vw' }">
        <div>
                <DataTable 
                :value="sapMFGSearchTerm" 
                dataKey="SORTL" 
                tableStyle="min-width: 40rem" 
              >
                <Column field="IsSelect" header="IsSelect">
                   <template #body="slotProps">
                       <Checkbox v-model="slotProps.data.IsSelect" :binary="true" :disabled="(!MaterialGroup && (slotProps.data.IsUsed==true || slotProps.data.IsApplied==true)) ||  check_MFGSearchTerm_BGS(slotProps.data.SORTL,slotProps.data.BGS)" />          
                   </template>
                 </Column>
                   <Column field="SORTL" header="Search Term"></Column>
                   <Column field="NAME" header="Name"></Column>
                   <Column  field="SORTL" header="PCBG">
                    <template #body="slotProps">
                        <div v-if="check_MFGSearchTerm_BGOld(slotProps.data.SORTL,'PCBG')==true">
                                {{ $t("message.m002") }}
                        </div>
                        <div v-else-if="check_MFGSearchTerm_BG(slotProps.data.SORTL,'PCBG')==true">
                            <i class="pi pi-check"></i>
                        </div>
                    </template>
                 </Column>
                 <Column  field="SORTL" header="SDBG">
                    <template #body="slotProps">
                        <div v-if="check_MFGSearchTerm_BGOld(slotProps.data.SORTL,'SDBG')==true">
                                {{ $t("message.m002") }}
                        </div>
                        <div v-if="check_MFGSearchTerm_BG(slotProps.data.SORTL,'SDBG')==true">
                            <i class="pi pi-check"></i>
                        </div>
                    </template>
                 </Column>
                </DataTable>
           
            <br />
            <Button label="確定" @click="Confirm" :disabled="button_disable"></Button>
        </div>
    </Dialog>
     
</template>  
<script>
 


import Service from "../../service/service";
import SapService from "../../service/SapService";


export default {
    props: ["modelValue", "Category", 'disabled','ApplyMFGSearchTerm','ApplyMFG'],
    emits: ["update:modelValue"],
    data() {
        return {
            inputText: "",
            sapMFG: [],
            sapMFGSearchTerm: [],
            selectedMFG: [],
            showDialog: false,
            placeholder: "請輸入",
            button_disable:true,
        }
    },
    Service: null,
    SapService: null,
    
    created() {
        this.Service = new Service();
        this.SapService = new SapService();
        this.selectedMFG=this.modelValue;
       
    },
    
    methods: {

        check_MFGSearchTerm_BGS(MFGSearchTerm,BGS){
        if(this.ApplyMFGSearchTerm.filter(x=>x.MFGSearchTerm==MFGSearchTerm && x.BGS==BGS).length==0){
            return false;  
        }
        else{
            return true;  
        }
        },

        check_MFGSearchTerm_BGOld(MFGSearchTerm,BG){
        if(this.ApplyMFGSearchTerm.filter(x=>x.MFGSearchTerm==MFGSearchTerm && x.BGS_Old.includes(BG)).length==0){
            return false;  
        }
        else{
            return true;  
        }
        },
        check_MFGSearchTerm_BG(SORTL,BG){
            let self=this;
            if(self.sapMFGSearchTerm.filter(x=>x.SORTL==SORTL && x.BGS.includes(BG)).length==0){
                return false;  
            }
            else{
                return true;  
            }
        },

        async CheckManufacturerCode() {
            let self=this;
            if (this.inputText.length > 0) 
            {
                let find_PCBG = undefined;
                let find_SDBG = undefined;
                if(this.ApplyMFGSearchTerm && this.ApplyMFGSearchTerm.length > 0){
                    let find = this.ApplyMFGSearchTerm.find(x=>x.MFGSearchTerm==this.inputText);
                    if(find!=undefined)
                    {
                        find_PCBG = this.ApplyMFGSearchTerm.find(x=>x.MFGSearchTerm==this.inputText && x.BGS.includes('PCBG'));
                        find_SDBG = this.ApplyMFGSearchTerm.find(x=>x.MFGSearchTerm==this.inputText && x.BGS.includes('SDBG'));

                        if(find_PCBG!=undefined && find_SDBG!=undefined){
                            alert('Manufacturer Code is exist!')
                            return;
                        }
                    }
                }

               await this.SapService.GetSpuervisorSAPMFG(self.inputText).then((data) => {
                  self.sapMFGSearchTerm = data;

                 
                 
                  for(let i=0;i<self.sapMFGSearchTerm.length;i++)
                  {
                    let SORTL=self.sapMFGSearchTerm[i].SORTL;
                    let BGS=self.sapMFGSearchTerm[i].BGS;
                    //let f=self.check_MFGSearchTerm_BGS(SORTL,BGS)
                    if(self.ApplyMFGSearchTerm.filter(x=>x.MFGSearchTerm==SORTL && x.BGS==BGS).length==0){
                        self.button_disable=false;   
                    }
                  }


                })

                
            }
           

            if (this.sapMFGSearchTerm.length == 0) {
                this.$toast.add({
                    severity: 'warn', summary: 'Warn Message', detail: '查無資料', life: 3000
                });
                this.showDialog = false
            }
            else {
                this.showDialog = true
            }
        },
         
        Confirm() {
            let self=this;
            this.showDialog = false;
            self.$emit("onConfirm",this.sapMFGSearchTerm.filter(x=>x.IsSelect==true));
        }
    },
    watch: {
        Category: function() {
            if (this.Category && this.Category != undefined && this.Category != "D") {
                this.IsDisabled = false;
                this.placeholder = "Manufacturer Code"
            }
            else if (this.Category == "D") {
                this.IsDisabled = true;
                this.placeholder = "XX Material supplier 不需要 key in Manufacturer Code"
            }
            else {
                this.IsDisabled = true;
            }
        },
        selectedManufacturerCode: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", this.newVal );
            },
    },
    computed: {
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
    user() {
     return this.$store.state.user;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },


    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },


     

  },
}
</script>
  
  